const UserTypes = [
  null,
  "Administrador",
  "Analísta",
  "Agente Aduanal",
  "Almacenista",
];

export default UserTypes;